<template>
    <div class="com-merchant-apply">
        <div class="container">
            <div class="com-merchant-apply__domain" v-if="step==='0'">
                <apply-domain @end="reflesh"></apply-domain>
            </div>
            <div class="com-merchant-apply__website" v-if="step==='1'">
                <apply-website @end="reflesh"></apply-website>
            </div>
            <div class="com-merchant-apply__email" v-if="step==='2'">
                <apply-email @end="reflesh"></apply-email>
            </div>
            <div class="com-merchant-apply__warehouse" v-if="step==='3'">
                <apply-warehouse @end="reflesh"></apply-warehouse>
            </div>
            <div class="com-merchant-apply__result" v-if="step==='4'">
                <apply-result @end="reflesh"></apply-result>
            </div>
        </div>
    </div>
</template>

<script>
import ApplyDomain from './components/domain'
import ApplyWebsite from './components/website'
import ApplyEmail from './components/email'
import ApplyWarehouse from './components/warehouse'
import ApplyResult from './components/result'
export default {
    name: 'merchant-apply',
    components: {
        ApplyDomain,
        ApplyWebsite,
        ApplyEmail,
        ApplyWarehouse,
        ApplyResult
    },
    data() {
        return {
            step: 0
        }
    },
    created() {
        const query = this.$route.query;
        this.step = query.s;
    },
    methods: {
        reflesh() {
            const query = this.$route.query;
            this.step = query.s.toString();
        }
    }
}
</script>

<style lang="less">
    .com-merchant-apply {
        margin: 10px auto;
        .container {
            padding: 0;
            > div {
                padding: 10px 20px;
            }
        }
    }
    @media only screen and (max-width: 750px) {
        .com-merchant-apply {
            margin: 0;
            .container {
                min-height: 100vh;
                padding: 0;
                > div {
                    padding: 10px 20px;
                }
            }
            .com-form-item {
                display: block;
            }
            .com-form__item-label {
                width: 100%;
                margin-bottom: 0.2rem;
                text-align: left;
            }
            .com-form__item-input {
                width: 95%;
                height: 0.9rem;
                font-size: 0.37rem;
            }
            .com-form-item--nolabel {
                padding-left: 0;
            }
            .com-btn {
                height: 0.9rem;
                line-height: 0.9rem;
            }
            .com-form__item-explain {
                display: inline-block;
                width: 100%;
                padding-top: 0.1rem;
                margin-left: 0;
            }
            .com-steps {
                display: none;
            }
        }
    }
</style>


